import { type ReactNode } from 'react';
import { Copy } from '@ev-tech/ui-core-components/Copy';

import styles from './PropertyDetails.module.css';

export type PropertyFactProps = {
  label: string;
  content: ReactNode;
};
export const PropertyFact = ({ label, content, isLast }: PropertyFactProps & { isLast: boolean }) => {
  return (
    <li className={styles.factContainer} data-is-last={isLast}>
      <Copy className={styles.copy} text={label} data-label={true} as="div" />
      {typeof content === 'string' || typeof content === 'number' ? (
        <Copy className={styles.copy} text={content.toString()} />
      ) : (
        <div className={styles.componentContainer}>{content}</div>
      )}
    </li>
  );
};
